import { RECEIVE_LIFE_PLAN } from '../actions/life';

export default function life(state = {}, action) {
  Object.freeze(state);

  switch (action.type) {
    case RECEIVE_LIFE_PLAN:
      return action.lifePlan;
    default:
      return state;
  }
}
